

import DialoguePopup from "../../helpers/DialoguePopup";
import React, { useState, useRef, useEffect, Fragment } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import BankService from "../../services/bank.services";
import BoLoader from "../../helpers/BoLoader";
import "react-phone-input-2/lib/style.css";
import { useSelector } from "react-redux";
import RefreshToken from "../../helpers/RefreshToken";
import counties from "./Helpers/IsoCountriesList";

const AddIndividualCorporateBody = props => {
    const { user: currentUser } = useSelector(state => state.auth);

    const [cardHolderDetailsAreaSelected, setCardHolderDetailsAreaSelected] =
        useState("true");
    const [cardDetailsAreaSelected, setCardDetailsAreaSelected] =
        useState("false");
    const [cardHolderDetailsClassName, setTcardHolderDetailsClassName] =
        useState("nav-link active");
    const [cardDetailsClassName, setTcardDetailsClassName] = useState("nav-link");
    const [cardHolderContentClassName, setCardHolderContentClassName] = useState(
        "tab-pane fade show active"
    );
    const [cardContentClassName, setCardContentClassName] =
        useState("tab-pane fade");
    const [modalShow, setModalShow] = React.useState(false);
    const form = useRef();
    const checkBtn = useRef();
    const [modelhdng, setMdlHdng] = useState("");
    const [MdlIcon, setMdlIcon] = useState("");
    const [modelbdy, setMdlBdy] = useState("");
    const [disableBtns, setDisabledBtns] = useState(false);
    const [boloader, setBoLoader] = useState(false);
    const [FirstName, setFirstName] = useState("");
    const [errors, setErrors] = useState({}); // Error state

    //Issuer S or ISsuer B For m-Swipe
    const [formData, setFormData] = useState({
        corporateApplicationId: props?.corporateApplicationId,
        individualType: '',
        firstName: '',
        lastName: '',
        emailAddress: '',
        telephoneNumber: '',
        mailingUnitNumber: '',
        mailingAddressLine1: '',
        mailingAddressLine2: '',
        mailingCity: '',
        mailingStateCode: '',
        mailingPostalCode: '',
        mailingCountryCode: '',
        taxReferenceNumber: 0,
        passportNumber: '',
        nationality: '',
        citizenship: '',
        dateOfBirth: '',
        usResidencyStatus: '',
        percentageOwnership: 0,
        clientId: props?.clientid
    });

    // Custom validation rules
    const validateField = (name, value) => {
        let errorMsg = "";

        // Ensure value is a string before using trim()
        const strValue = value !== undefined && value !== null ? String(value).trim() : "";

        if (!strValue) {
            errorMsg = `${name} is required`;
        } else {
            if (name === "email" && !/^\S+@\S+\.\S+$/.test(strValue)) {
                errorMsg = "Invalid email format";
            }
            if (name === "phone" && !/^\d{10,15}$/.test(strValue)) {
                errorMsg = "Invalid phone number (must be 10-15 digits)";
            }
        }

        return errorMsg;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Validate field
        const errorMsg = validateField(name, value);

        // Update state
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Update errors
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMsg,
        }));
    };
    //API Call Start
    const IssueCardHolderHandler = e => {
        if (e) e.preventDefault();
        form.current.validateAll();
        let newErrors = {};
        Object.keys(formData).forEach((field) => {
            const errorMsg = validateField(field, formData[field]);
            if (errorMsg) newErrors[field] = errorMsg;
        });
        // If errors exist, update state and stop submission
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        formData.clientId=Number(formData?.clientId);
        formData.taxReferenceNumber=Number(formData?.taxReferenceNumber);
        formData.percentageOwnership=Number(formData?.percentageOwnership);
        setBoLoader(true);
        BankService.addindividualtocorporate
            (formData,
            )
            .then(bankData => {
                setBoLoader(false);
                if (bankData && bankData.data && bankData.data.success) {
                    let errIcon = "icon-success";
                    let msgBody= "Account created Successfully please check your email !"
                    errorAndSuccessModl("Success", msgBody, errIcon);
                }
            })
            .catch(err => {
                setBoLoader(false);
                let msgBody =
                    err && err.response && err.response.data
                        ? err.response.data.message
                        : "Error Occured While Creating Account";
                let errIcon = "icon-error";
                errorAndSuccessModl("Error", msgBody, errIcon);
                (async () => {
                    setBoLoader(true);
                    let resp = await RefreshToken(
                        err && err.response && err.response.status
                    );
                    if (resp) {
                        IssueCardHolderHandler();
                        setBoLoader(false);
                    } else {
                        setBoLoader(false);
                    }
                })();
            });


    };
    //API Call End
    const errorAndSuccessModl = (heading, body, Icon) => {
        setModalShow(true);
        setMdlHdng(heading);
        setMdlBdy(body);
        setMdlIcon(Icon);
    };

    const IssueCardDoneHandler = e => {
        e.preventDefault();
        // setDisabledBtns(true);
        props.onHide();
    };


    return (
        <Fragment>
            <div className="row">
                <BoLoader loading={boloader} />
                <div className="col-md-12">
                    <h2>External Transfer </h2>
                    <div className="mt-16">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="bo-tabs-mbl">
                                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className={cardHolderDetailsClassName} //""
                                                id="cardHolder-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#cardHolder"
                                                type="button"
                                                role="tab"
                                                aria-controls="cardHolder"
                                                aria-selected={cardHolderDetailsAreaSelected}
                                            >
                                                Add Indivdual Account
                                            </button>
                                        </li>

                                    </ul>
                                </div>

                                <div className="tab-content" id="myTabContent">
                                    <div
                                        className={cardHolderContentClassName}
                                        id="cardHolder"
                                        role="tabpanel"
                                        aria-labelledby="cardHolder-tab"
                                    >
                                        <div>
                                            <h3>Enter Account details</h3>
                                            <Form onSubmit={(e) => { e.preventDefault() }} ref={form}>
                                                <div className="row mt-16">
                                                    {/* Individual Type */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_individualType">
                                                            <label>Individual Type*</label>
                                                            <div className="form-controls">
                                                                <select
                                                                    className="form-control no-icon"
                                                                    name="individualType"
                                                                    value={formData.individualType}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="INDIVIDUAL">Individual</option>
                                                                    <option value="OFFICER">Officer</option>
                                                                    <option value="BENEFICIAL_OWNER">Beneficial Owner</option>
                                                                    <option value="CONTROL_PERSON">Control Person</option>
                                                                    <option value="AUTHORIZED_PERSON">Authorized Person</option>
                                                                </select>
                                                            </div>
                                                            {errors.individualType && <span className="error_meesage">{errors.individualType}</span>}
                                                        </div>
                                                    </div>

                                                    {/* First Name */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_firstName">
                                                            <label>First Name*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="firstName"
                                                                    value={formData.firstName}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.firstName && <span className="error_meesage">{errors.firstName}</span>}
                                                        </div>
                                                    </div>

                                                    {/* Last Name */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_lastName">
                                                            <label>Last Name*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="lastName"
                                                                    value={formData.lastName}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.lastName && <span className="error_meesage">{errors.lastName}</span>}
                                                        </div>
                                                    </div>

                                                    {/* Email Address */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_emailAddress">
                                                            <label>Email Address*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="email"
                                                                    className="form-control no-icon"
                                                                    name="emailAddress"
                                                                    value={formData.emailAddress}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.emailAddress && <span className="error_meesage">{errors.emailAddress}</span>}
                                                        </div>
                                                    </div>

                                                    {/* Telephone Number */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_telephoneNumber">
                                                            <label>Telephone Number*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="tel"
                                                                    className="form-control no-icon"
                                                                    name="telephoneNumber"
                                                                    value={formData.telephoneNumber}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.telephoneNumber && <span className="error_meesage">{errors.telephoneNumber}</span>}
                                                        </div>
                                                    </div>

                                                    {/* Mailing Unit Number */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_mailingUnitNumber">
                                                            <label>Mailing Unit Number</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="mailingUnitNumber"
                                                                    value={formData.mailingUnitNumber}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.mailingUnitNumber && <span className="error_meesage">{errors.mailingUnitNumber}</span>}
                                                        </div>
                                                    </div>

                                                    {/* Mailing Address Line 1 */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_mailingAddressLine1">
                                                            <label>Mailing Address Line 1*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="mailingAddressLine1"
                                                                    value={formData.mailingAddressLine1}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.mailingAddressLine1 && <span className="error_meesage">{errors.mailingAddressLine1}</span>}
                                                        </div>
                                                    </div>

                                                    {/* Mailing Address Line 2 */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_mailingAddressLine2">
                                                            <label>Mailing Address Line 2</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="mailingAddressLine2"
                                                                    value={formData.mailingAddressLine2}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.mailingAddressLine2 && <span className="error_meesage">{errors.mailingAddressLine2}</span>}
                                                        </div>
                                                    </div>

                                                    {/* Mailing City */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_mailingCity">
                                                            <label>Mailing City*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="mailingCity"
                                                                    value={formData.mailingCity}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.mailingCity && <span className="error_meesage">{errors.mailingCity}</span>}
                                                        </div>
                                                    </div>

                                                    {/* Mailing State Code */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_mailingStateCode">
                                                            <label>Mailing State Code*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="mailingStateCode"
                                                                    value={formData.mailingStateCode}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.mailingStateCode && <span className="error_meesage">{errors.mailingStateCode}</span>}
                                                        </div>
                                                    </div>
                                                    {/* Mailing Postal Code */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_mailingPostalCode">
                                                            <label>Mailing Postal Code*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="mailingPostalCode"
                                                                    value={formData.mailingPostalCode}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.mailingPostalCode && <span className="error_meesage">{errors.mailingPostalCode}</span>}
                                                        </div>
                                                    </div>

                                                    {/* Mailing Country Code */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_mailingCountryCode">
                                                            <label>Mailing Country*</label>
                                                            <div className="form-controls">
                                                                <select
                                                                    className="form-control no-icon"
                                                                    name="mailingCountryCode"
                                                                    value={formData.mailingCountryCode}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select Country</option>
                                                                    {counties.map((country) => (
                                                                        <option key={country.code} value={country.code}>
                                                                            {country.name} ({country.code})
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            {errors.mailingCountryCode && <span className="error_meesage">{errors.mailingCountryCode}</span>}
                                                        </div>
                                                    </div>

                                                    {/* Tax Reference Number */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_taxReferenceNumber">
                                                            <label>Tax Reference Number*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="taxReferenceNumber"
                                                                    value={formData.taxReferenceNumber}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.taxReferenceNumber && <span className="error_meesage">{errors.taxReferenceNumber}</span>}
                                                        </div>
                                                    </div>

                                                    {/* Passport Number */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_passportNumber">
                                                            <label>Passport Number*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="passportNumber"
                                                                    value={formData.passportNumber}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.passportNumber && <span className="error_meesage">{errors.passportNumber}</span>}
                                                        </div>
                                                    </div>

                                                    {/* Nationality */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_nationality">
                                                            <label>Nationality*</label>
                                                            <div className="form-controls">
                                                                <select
                                                                    className="form-control no-icon"
                                                                    name="nationality"
                                                                    value={formData.nationality}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select Nationality...</option>
                                                                    {counties.map((country) => (
                                                                        <option key={country.code} value={country.code}>
                                                                            {country.name} ({country.code})
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            {errors.nationality && <span className="error_meesage">{errors.nationality}</span>}
                                                        </div>
                                                    </div>

                                                    {/* Citizenship */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_citizenship">
                                                            <label>Citizenship*</label>
                                                            <div className="form-controls">
                                                                <select
                                                                    className="form-control no-icon"
                                                                    name="citizenship"
                                                                    value={formData.citizenship}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select Citizenship</option>
                                                                    {counties.map((country) => (
                                                                        <option key={country.code} value={country.code}>
                                                                            {country.name} ({country.code})
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            {errors.citizenship && <span className="error_meesage">{errors.citizenship}</span>}
                                                        </div>
                                                    </div>

                                                    {/* Date of Birth */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_dateOfBirth">
                                                            <label>Date of Birth*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="date"
                                                                    className="form-control no-icon"
                                                                    name="dateOfBirth"
                                                                    value={formData.dateOfBirth}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.dateOfBirth && <span className="error_meesage">{errors.dateOfBirth}</span>}
                                                        </div>
                                                    </div>


                                                    {/* US Residency Status */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_usResidencyStatus">
                                                            <label>US Residency Status*</label>
                                                            <div className="form-controls">
                                                                <select
                                                                    className="form-control no-icon"
                                                                    name="usResidencyStatus"
                                                                    value={formData.usResidencyStatus}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="US_CITIZEN">US Citizen</option>
                                                                    <option value="RESIDENT_ALIEN">Resident Alien</option>
                                                                    <option value="NON_RESIDENT_ALIEN">Non-Resident Alien</option>
                                                                </select>
                                                            </div>
                                                            {errors.usResidencyStatus && <span className="error_meesage">{errors.usResidencyStatus}</span>}
                                                        </div>
                                                    </div>

                                                    {/* Percentage Ownership (Only for Beneficial Owner) */}
                                                    {formData.individualType === "BENEFICIAL_OWNER" && (
                                                        <div className="col-md-6">
                                                            <div className="form-group" id="id_percentageOwnership">
                                                                <label>Percentage Ownership*</label>
                                                                <div className="form-controls">
                                                                    <Input
                                                                        type="number"
                                                                        className="form-control no-icon"
                                                                        name="percentageOwnership"
                                                                        value={formData.percentageOwnership}
                                                                        onChange={handleChange}
                                                                    />
                                                                </div>
                                                                {errors.percentageOwnership && <span className="error_meesage">{errors.percentageOwnership}</span>}
                                                            </div>
                                                        </div>
                                                    )}



                                                    <div className="col-md-12">
                                                        <div className="form-group submit-field d-flex justify-content-end mt-20 mb-0">
                                                            <a
                                                                className="btn btn-outline mr-19"
                                                                data-bs-dismiss="modal"
                                                                onClick={props.onHide}
                                                            >
                                                                Cancel
                                                            </a>
                                                            <a className="btn btn-large" onClick={IssueCardHolderHandler}>
                                                                Create Account
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <CheckButton
                                                    style={{ display: "none" }}
                                                    ref={checkBtn}
                                                />
                                            </Form>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DialoguePopup
                show={modalShow}
                onHide={() => setModalShow(false)}
                modelheading={modelhdng}
                modelbody={modelbdy}
                modelicon={MdlIcon}
                hideallpopups={props.onHide}
            />
        </Fragment>
    );
};
export default AddIndividualCorporateBody;
